<template style="background-color:white">
  <section class="init_box" style="background-color: white">
    <el-row type="flex" justify="end" style="flex-wrap: wrap; flex-direction: row">
      <el-col :span="24" style="margin-top: 15px; padding-left: 10px">
        <el-button class="btn" size="small" type="primary" @click="export2Excel">导出借用台账</el-button>
        <!-- <el-button class="btn" size="small" type="danger" @click="import2Excel">导入历史台账</el-button> -->
      </el-col>
    </el-row>
    <el-row style="margin-top: 5px; flex-wrap: wrap; flex-direction: row" type="flex" justify="end">
      <el-col :span="5" style="float: left; margin-top: 10px">
        <el-button type="primary" class="statueBtn" style="background-color: green"></el-button><span class="statueSpan"
          style="">审核通过</span>
        <el-button type="primary" class="statueBtn" style="background-color: chocolate"></el-button><span
          class="statueSpan" style="">已出库</span>
        <el-button type="primary" class="statueBtn" style="background-color: #666666"></el-button><span
          class="statueSpan" style="">已结束</span>
      </el-col>
      <!-- 搜索框 -->
      <el-col :span="19">
        <el-form :model="searchModel" :inline="true" style="float: right" @submit.native.prevent>
          <el-form-item label="项目名称">
            <el-select placeholder="请选择项目" v-model="searchModel.projectName" clearable filterable style="width: 200px">
              <el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.projectName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="借用人">
            <el-input placeholder="请输入借用人" v-model="searchModel.userName" clearable style="width: 150px"></el-input>
          </el-form-item>
          <el-form-item label="项目状态">
            <el-select placeholder="请选择项目状态" v-model="searchModel.status" clearable style="width: 150px">
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="通过" :value="1"></el-option>
              <el-option label="已出库" :value="2"></el-option>
              <el-option label="已领用确认" :value="3"></el-option>
              <el-option label="已结束" :value="8"></el-option>
              <el-option label="不通过" :value="9"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发起时间">
            <el-date-picker
              v-model="searchModel.createTimeRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 240px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="searchList">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 数据展示表格 -->
      <el-col :span="24" style="margin-top: 5px">
        <el-table :data="dataList" ref="infoTable" id="infoTable" :header-cell-style="{ background: '#eff3f6' }" stripe
          :row-key="getRowKeys" style="
            width: 99%;
            margin: 0px auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          " height="600">
          <el-table-column type="selection" width="55" :reserve-selection="true" style="border-color: black">
          </el-table-column>
          <el-table-column type="index" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deviceNames" label="资产名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="300" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="addressName" label="使用区域" width="260" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="createBy" label="借用人" width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="getType" label="领用方式" width="100" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.getType == 1">自取</span>
              <span v-if="scope.row.getType == 2">邮寄</span>
              <span v-if="scope.row.getType == 3">委托他人</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="发起时间" width="180" align="center"
            :show-overflow-tooltip="true">
            <template slot="header">
              <span>发起时间</span>
              <span style="margin-left:6px;padding:2px 4px;cursor:pointer;font-size:10px;display:inline-block;user-select:none;" :style="{color: searchModel.orderType === 'time' ? '#333' : '#999'}" @click="toggleSort('time')">{{ getSortIcon('time') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="180" align="center">
            <template slot="header">
              <span>状态</span>
              <span style="margin-left:6px;padding:2px 4px;cursor:pointer;font-size:10px;display:inline-block;user-select:none;" :style="{color: searchModel.orderType === 'status' ? '#333' : '#999'}" @click="toggleSort('status')">{{ getSortIcon('status') }}</span>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0 || scope.row.status == '0'" style="color: orange">待审核</span>
              <span v-else-if="scope.row.status == 1 || scope.row.status == '1'" style="color: green">通过</span>
              <span v-else-if="scope.row.status == 2 || scope.row.status == '2'" style="color: chocolate">已出库</span>
              <span v-else-if="scope.row.status == 3 || scope.row.status == '3'" style="color: darkgreen">已领用确认</span>
              <span v-else-if="scope.row.status == 4 || scope.row.status == '4'" style="color: #909399">草稿</span>
              <span v-else-if="scope.row.status == 5 || scope.row.status == '5'" style="color: #c0c4cc">已撤回</span>
              <span v-else-if="scope.row.status == 8 || scope.row.status == '8'" style="color: dimgray">已结束</span>
              <span v-else-if="scope.row.status == 9 || scope.row.status == '9'" style="color: red">不通过</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="selectClick(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :current-page="pageIndex"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
    <div style="
        position: fixed;
        top: 18%;
        left: 600px;
        height: 50px;
        width: 50px;
        font-size: 20px;
      " @click="checkBoxdialog = true" v-if="checkBoxData.length > 0">
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <!-- <span class="iconfont icon--task- " style="width:100%;height:100%;font-size: 40px"></span> -->
        <img src="../../../static/img/selects.png" style="width: 70%; height: 70%; font-size: 40px" />
      </el-badge>
    </div>
    <!-- 查看详细 -->
    <el-dialog :visible.sync="viewShow" title="查看详细" :close-on-click-modal="false" :close-on-press-escape="false"
      width="80%">
      <el-form :model="viewForm" ref="viewForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left: 5%">
        <el-row>
          <el-col :span="24">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="项目名称">{{
                viewForm.projectName
              }}</el-descriptions-item>
              <el-descriptions-item label="使用区域" :span="2">{{
                viewForm.addressName
              }}</el-descriptions-item>
              <el-descriptions-item label="详细地址">
                {{ viewForm.addressDetail }}
              </el-descriptions-item>
              <el-descriptions-item label="借用日期">{{ viewForm.borrowDateStart }} 至
                {{ viewForm.borrowDateEnd }}</el-descriptions-item>
              <el-descriptions-item label="领用方式">
                <span v-if="viewForm.getType == 1">自取</span>
                <span v-if="viewForm.getType == 2">邮寄</span>
                <span v-if="viewForm.getType == 3">委托他人</span>
              </el-descriptions-item>
              <el-descriptions-item label="邮寄地址" v-if="viewForm.getType == '2'">
                {{ viewForm.name }} {{ viewForm.phone }} {{ viewForm.address }}
              </el-descriptions-item>
              <el-descriptions-item label="委托人姓名" v-if="viewForm.getType == '3'">
                {{ viewForm.persion }}
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
        <div>
          <div style="line-height: 40px; font-size: 14px; text-align: left">
            资产列表
          </div>
          <div>
            <el-table :data="viewForm.detailList" style="width: 100%; text-align: center" size="mini" max-height="500px"
              :header-cell-style="{
                textAlign: 'center',
                background: '#eff3f6',
              }" :cell-style="{ textAlign: 'center' }">
              <el-table-column prop="deviceinfo.glbh" label="管理编号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="deviceinfo.zcmc" label="资产名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="deviceinfo.sbxh" label="规格型号" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="status" label="在库情况" show-overflow-tooltip v-if="
                viewForm.status == '1' ||
                viewForm.status == '2' ||
                viewForm.status == '3'
              ">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0" style="color: green">在库</span>
                  <span v-else-if="scope.row.status == 1" style="color: chocolate">借出</span>
                  <span v-else-if="scope.row.status == 2" style="color: green">已归还</span>
                  <span v-else-if="scope.row.status == 9 || scope.row.status == '9'" style="color: #c0c4cc">不出库</span>
                  <span v-else style="color: rgb(64, 149, 229)">--</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="调换状态" show-overflow-tooltip v-if="
                viewForm.status == '1' ||
                viewForm.status == '2' ||
                viewForm.status == '3'
              ">
                <template slot-scope="scope">
                  <span v-if="scope.row.exchangeStatus == '0'" style="color: green">--</span>
                  <span v-else-if="scope.row.exchangeStatus == '1'">调入</span>
                  <span v-else-if="scope.row.exchangeStatus == '2'" style="color: chocolate">调出</span>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="操作" width="240px">
                <template slot-scope="scope">
                  <span v-if="
                    viewForm.status == '1' &&
                    scope.row.status == '0' &&
                    (scope.row.exchangeStatus == '0' ||
                      scope.row.exchangeStatus == '1')
                  ">
                    <el-button @click="outbound(scope.row)" type="text" size="small">出库</el-button>
                    <el-button @click="cancelOutbound(scope.row)" type="text" size="small" style="margin-left: 8px;">不出库</el-button>
                  </span>
                  <span v-if="
                    (viewForm.status == '2' || viewForm.status == '3') &&
                    scope.row.status == '1' &&
                    (scope.row.exchangeStatus == '0' ||
                      scope.row.exchangeStatus == '1')
                  ">
                    <el-button @click="store(scope.row)" type="text" size="small">入库</el-button>
                  </span>
                  <span v-if="viewForm.status == '1' && scope.row.status == '0'" class="exchange" style="margin-left: 8px;">
                    <!-- 只有在通过审核的情况下才可以调换 -->
                    <DC :transferValue="transferValue" :rowInfo="scope.row" :parameter="{ isMarket: '1' }"
                      v-if="scope.row.exchangeStatus == '0'" buttonText="调换" buttonType="text" :buttonSize="'small'"></DC>
                  </span>
                  <span v-if="scope.row.status == 1 || scope.row.status == 2">
                    <el-button @click="viewLend(scope.row)" type="text" size="small">出入库记录</el-button>
                    <el-button @click="openUsageRecord(scope.row)" type="text" size="small">使用记录</el-button>
                    <el-button @click="openMaintenanceRecord(scope.row)" type="text" size="small">维护记录</el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 审核信息 -->
        <div style="margin-top: 20px; text-align: left; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
          <div style="font-weight: bold; color: #606266; margin-bottom: 8px;">审核信息:</div>
          <div style="color: #909399; line-height: 1.6;">审核意见：{{ viewForm.remark || '-' }}</div>
          <div style="color: #909399; line-height: 1.6;">审核时间：{{ viewForm.auditTime || '-' }}</div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button style="margin-left: 10px" type="info" @click="viewShow = false">关闭</el-button>
        <el-button style="margin-left: 10px" v-if="viewForm.status == '0'" type="primary"
          @click="auditHandle">审核</el-button>
      </div>
    </el-dialog>

    <!-- 审核意见 -->
    <el-dialog :visible.sync="auditShow" title="审核意见" width="500px" :close-on-click-modal="false"
      :close-on-press-escape="false" label-position="left" label-width="100px">
      <el-form :model="auditForm" ref="auditForm" :rules="auditRules" label-position="left" label-width="100px">
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="审核意见" prop="remark">
              <el-input type="textarea" placeholder="请输入审核意见" v-model.trim="auditForm.remark" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="审核状态" prop="status">
              <el-radio-group v-model="auditForm.status">
                <el-radio :label="1">通过</el-radio>
                <el-radio :label="2">不通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" type="info" @click="auditShow = false">关闭</el-button>
        <el-button style="margin-left: 10px" type="primary" @click="auditOk">确定</el-button>
      </div>
    </el-dialog>

    <!-- 导入借用台账 -->
    <el-dialog :visible.sync="importDialogShow" title="导入历史台账" :close-on-click-modal="false"
      :close-on-press-escape="false" width="500px">
      <div>
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="handleImportFile"
          accept=".xlsx,.xls">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击选择</em></div>
          <div class="el-upload__tip" slot="tip">只能上传.xlsx或.xls文件</div>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" type="info"
          @click="importDialogShow = false; importFile = null">关闭</el-button>
        <el-button style="margin-left: 10px" type="primary" @click="confirmImport">确定导入</el-button>
      </div>
    </el-dialog>

    <!-- 出库 -->
    <el-dialog :visible.sync="outboundShow" title="出库" width="800px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="outboundForm" label-width="140px" align="left">
        <el-form-item label="出库照片:">
          <el-upload :limit="5" :auto-upload="true" list-type="picture-card" :file-list="outboundFileList"
            class="outbound-upload" :http-request="uploadRequest">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否有损坏:">
          <el-radio-group v-model="outboundForm.devicestatusOut">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出库备注:">
          <el-input type="textarea" v-model="outboundForm.remarkOut" placeholder="请输入出库备注" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outboundShow = false">取消</el-button>
        <el-button type="primary" @click="confirmOutbound">确定</el-button>
      </div>
    </el-dialog>

    <!-- 入库 -->
    <el-dialog :visible.sync="storeShow" title="入库" width="800px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="storeForm" label-width="140px" align="left">
        <el-form-item label="入库照片:">
          <el-upload :limit="5" :auto-upload="true" list-type="picture-card" :file-list="storeFileList"
            class="outbound-upload" :http-request="storeUploadRequest">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="是否有损坏:">
          <el-radio-group v-model="storeForm.devicestatus">
            <el-radio label="0">否</el-radio>
            <el-radio label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="入库备注:">
          <el-input type="textarea" v-model="storeForm.remark" placeholder="请输入入库备注" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="storeShow = false">取消</el-button>
        <el-button type="primary" @click="confirmStore">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="lendShow" title="借还记录" width="1000px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-descriptions :column="2" border label-width="200px">
        <el-descriptions-item label="出库人">{{
          lendForm.outUserText
        }}</el-descriptions-item>
        <el-descriptions-item label="出库时间">{{
          lendForm.outTime
        }}</el-descriptions-item>
        <el-descriptions-item label="出库是否有损坏">{{
          lendForm.devicestatusOut == '1' ? '是' : '否'
        }}</el-descriptions-item>
        <el-descriptions-item label="出库照片" :span="2" v-if="lendForm.prePhotos">
          <el-image style="height: 100px" :src="getFullUrl(lendForm.prePhotos)"
            :preview-src-list="lendForm.prePhotoUrls"></el-image>
          <span style="margin-left: 10px">共{{
            lendForm.prePhotoUrls ? lendForm.prePhotoUrls.length : 0
            }}张</span>
        </el-descriptions-item>
        <el-descriptions-item label="出库备注" v-if="lendForm.remarkOut">
          {{ lendForm.remarkOut }}
        </el-descriptions-item>
        <el-descriptions-item label="入库人" v-if="lendForm.status == '2'">{{
          lendForm.inUserText
        }}</el-descriptions-item>
        <el-descriptions-item label="入库时间" v-if="lendForm.status == '2'">{{
          lendForm.inTime
        }}</el-descriptions-item>
        <el-descriptions-item label="入库照片" v-if="lendForm.status == '2' && lendForm.photoUrls">
          <el-image style="height: 100px" :src="getFullUrl(lendForm.photos)"
            :preview-src-list="lendForm.photoUrls"></el-image>
          <span style="margin-left: 10px">共{{ lendForm.photoUrls ? lendForm.photoUrls.length : 0 }}张</span>
        </el-descriptions-item>
        <el-descriptions-item label="入库签名" v-if="lendForm.status == '2' && lendForm.signPic">
          <el-image style="height: 100px" :src="getFullUrl(lendForm.signPic)"
            :preview-src-list="[getFullUrl(lendForm.signPic)]"></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="入库是否有损坏" v-if="lendForm.status == '2'">{{
          lendForm.devicestatus == '1' ? '是' : '否'
          }}</el-descriptions-item>
        <el-descriptions-item label="入库备注" v-if="lendForm.status == '2' && lendForm.remark">
          {{ lendForm.remark }}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" type="info" @click="lendShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 使用记录弹窗 -->
    <el-dialog :visible.sync="usageRecordShow" title="使用记录" width="1100px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 10px; text-align: right;">
        <el-button type="success" size="small" @click="exportUsageRecord">导出</el-button>
      </div>
      <el-table :data="usageRecordList" :header-cell-style="{ background: '#eff3f6' }" max-height="400"
        style="width: 100%">
        <el-table-column prop="useDate" label="使用日期" width="120" align="center"></el-table-column>
        <el-table-column prop="sampleName" label="样品名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sampleCode" label="样品编号" width="140" align="center"></el-table-column>
        <el-table-column label="开始时间" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.startTime ? scope.row.startTime.substring(0, 5) : '--' }}</template>
        </el-table-column>
        <el-table-column label="结束时间" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.endTime ? scope.row.endTime.substring(0, 5) : '--' }}</template>
        </el-table-column>
        <el-table-column prop="statusBeforeUse" label="使用前状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusBeforeUse == 1" style="color: green">正常</span>
            <span v-else-if="scope.row.statusBeforeUse == 2" style="color: red">异常</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusAfterUse" label="使用后状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusAfterUse == 1" style="color: green">正常</span>
            <span v-else-if="scope.row.statusAfterUse == 2" style="color: red">异常</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="usePerson" label="使用人" width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button @click="editUsageRecord(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteUsageRecord(scope.row.id)" type="text" size="small"
              style="color: red">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="usageRecordShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑使用记录弹窗 -->
    <el-dialog :visible.sync="usageRecordEditShow" title="编辑使用记录" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false" append-to-body>
      <el-form :model="usageRecordEditForm" label-width="100px">
        <el-form-item label="使用日期" required>
          <el-date-picker v-model="usageRecordEditForm.useDate" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择使用日期" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="样品名称">
          <el-input v-model="usageRecordEditForm.sampleName" placeholder="请输入样品名称"></el-input>
        </el-form-item>
        <el-form-item label="样品编号">
          <el-input v-model="usageRecordEditForm.sampleCode" placeholder="请输入样品编号"></el-input>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-time-picker v-model="usageRecordEditForm.startTime" value-format="HH:mm" placeholder="开始时间"
            style="width: 100%"></el-time-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-time-picker v-model="usageRecordEditForm.endTime" value-format="HH:mm" placeholder="结束时间"
            style="width: 100%"></el-time-picker>
        </el-form-item>
        <el-form-item label="使用前状态">
          <el-select v-model="usageRecordEditForm.statusBeforeUse" placeholder="请选择" style="width: 100%" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="异常" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用后状态">
          <el-select v-model="usageRecordEditForm.statusAfterUse" placeholder="请选择" style="width: 100%" clearable>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="异常" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用人">
          <el-input v-model="usageRecordEditForm.usePerson" placeholder="请输入使用人"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="usageRecordEditForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="usageRecordEditShow = false">取消</el-button>
        <el-button type="primary" @click="submitUsageRecordEdit" v-preventReClick>保存</el-button>
      </div>
    </el-dialog>

    <!-- 维护记录弹窗 -->
    <el-dialog :visible.sync="maintenanceRecordShow" title="维护记录" width="1100px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 15px; display: flex; justify-content: flex-end; align-items: center;">
        <span style="color: #909399; font-size: 12px; margin-right: 10px;">设备：{{ maintenanceDeviceName }}</span>
        <el-button type="success" size="small" @click="exportMaintenanceRecord">导出</el-button>
      </div>
      <el-table :data="maintenanceRecordList" :header-cell-style="{ background: '#eff3f6' }" max-height="400"
        style="width: 100%">
        <el-table-column prop="maintenanceTime" label="维护日期" width="120" align="center"></el-table-column>
        <el-table-column prop="deviceCode" label="设备编号" width="140" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maintenanceContent" label="维护内容" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maintenancePerson" label="维护人" width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-button @click="editMaintenanceRecord(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="deleteMaintenanceRecord(scope.row.id)" type="text" size="small"
              style="color: red">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="maintenanceRecordShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 新增/编辑维护记录弹窗 -->
    <el-dialog :visible.sync="addMaintenanceRecordShow"
      :title="maintenanceRecordForm.id ? '编辑维护记录' : '新增维护记录'" width="600px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form :model="maintenanceRecordForm" ref="maintenanceRecordFormRef" label-width="100px">
        <el-form-item label="维护日期" prop="maintenanceTime" required>
          <el-date-picker v-model="maintenanceRecordForm.maintenanceTime" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择维护日期" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="维护内容" prop="maintenanceContent" required>
          <el-input v-model="maintenanceRecordForm.maintenanceContent" type="textarea" :rows="3"
            placeholder="请输入维护内容"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="maintenanceRecordForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addMaintenanceRecordShow = false">取消</el-button>
        <el-button type="primary" @click="submitMaintenanceRecord">保存</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import DeviceinfoCard from "./Deviceinfo_card.vue";
import deviceinfoCardPL from "./Deviceinfo_cardPL.vue";
import MultipleDevices from "../../components/common/MultipleDevices.vue";
import { base } from "../../api/api";
import {
  mktBorrowSelectConfirm,
  mktBorrowAudit,
  mktBorrowView,
  mktExchange,
  mktBorrowViewDetail,
  mktSetDevice,
  exportMarketRecord,
  importMarketRecord,
  uploadImage,
  mktUsageRecordListByBorrowId,
  mktUsageRecordUpdate,
  mktUsageRecordDelete,
  mktUsageRecordExport,
  mktMaintenanceRecordListByDeviceId,
  mktMaintenanceRecordAdd,
  mktMaintenanceRecordUpdate,
  mktMaintenanceRecordDelete,
  mktMaintenanceRecordExport,
  mktProjectUnfinishedList,
} from "../../api/api";
import WeibaoApplyVue from "../../components/common/WeibaoApply.vue";
import baoFeiApplyVue from "../../components/common/BaoFeiApply.vue";
import DeviceCardbg from "./deviceCardbg.vue";
const docxPre = require("docx-preview");
window.JSZip = require("jszip");
let id = 0;
export default {
  name: "Deviceinfo",
  components: {
    DeviceinfoCard,
    WeibaoApplyVue,
    baoFeiApplyVue,
    DeviceCardbg,
    deviceinfoCardPL,
    DC: MultipleDevices,
  },

  data() {
    return {
      companyProps: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
      },
      props: {
        label: "deviceTypeName",
        value: "id",
        children: "deviceTypes",
        expandTrigger: "click",
        emitPath: false,
        checkStrictly: true, //设置可以单选一级
      },
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      dataList: [],
      checkList: [],
      btnRole: [],
      searchModel: {
        projectName: "",
        status: "",
        userName: "",
        orderType: "status",
        sortDir: "asc",
        createTimeRange: [],
      },
      projectOptions: [],
      companySelect: [],
      deviceTypeSelect: [],
      check: [],
      checkList: [],
      checkBoxData: [],

      viewShow: false,
      viewForm: {},

      auditShow: false,
      auditForm: {
        id: null,
        status: null,
        remark: '',
      },
      auditRules: {
        status: [
          { required: true, message: "请选择审核状态", trigger: "blur" },
        ],
        remark: [
          { required: true, message: "请输入审核意见", trigger: "blur" },
        ],
      },

      lendShow: false,
      lendForm: {},
      usageRecordShow: false,
      usageRecordList: [],
      usageRecordRow: {},
      usageRecordEditShow: false,
      usageRecordEditForm: {},
      // 维护记录
      maintenanceRecordShow: false,
      maintenanceRecordList: [],
      maintenanceRecordRow: {},
      maintenanceDeviceName: '',
      addMaintenanceRecordShow: false,
      maintenanceRecordForm: {
        borrowId: null,
        deviceId: null,
        maintenanceTime: '',
        maintenanceContent: '',
        remark: ''
      },
      returnShow: false,
      importDialogShow: false,
      importFile: null,
      outboundShow: false,
      outboundForm: {
        detailId: '',
        deviceId: '',
        prePhotos: '',
        devicestatus: '',
        devicestatusOut: '0',
        remarkOut: ''
      },
      outboundFileList: [],
      storeShow: false,
      storeForm: {
        detailId: '',
        deviceId: '',
        prePhotos: '',
        devicestatus: '',
        remark: ''
      },
      storeFileList: [],
    };
  },
  watch: {
    'auditForm.status'(newVal) {
      if (newVal == 1) {
        this.auditForm.remark = '同意';
      } else if (newVal == 2) {
        this.auditForm.remark = '';
      }
    },
    'searchModel.orderType'() {
      this.getList(true);
    },
    'searchModel.sortDir'() {
      this.getList(true);
    },
    'searchModel.userName'(val) {
      // 输入或粘贴时去除左右空格
      if (val && val !== val.trim()) {
        this.searchModel.userName = val.trim();
      }
    },
  },
  methods: {
    // 获取完整图片URL
    getFullUrl(path) {
      if (!path) return ''
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path
      }
      return base + path
    },
    getProjectOptions() {
      mktProjectUnfinishedList({ pageIndex: 1, pageSize: 10000 }).then((datas) => {
        let { status, data } = datas;
        if (status == 200 && data && data.list) {
          this.projectOptions = data.list;
        }
      });
    },
    getList(resetPage) {
      if (resetPage) {
        this.pageIndex = 1;
      }
      // 过滤掉空值
      const params = { pageIndex: this.pageIndex, pageSize: this.pagesize };
      Object.keys(this.searchModel).forEach(key => {
        const val = this.searchModel[key];
        if (val === '' || val === null || val === undefined) return;
        if (key === 'createTimeRange') {
          // 拆分日期范围为开始/结束两个字段传给后端
          if (Array.isArray(val) && val.length === 2) {
            params.createTimeStart = val[0];
            params.createTimeEnd = val[1];
          }
        } else {
          params[key] = val;
        }
      });
      mktBorrowSelectConfirm(params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.dataList = data.list;
          this.total = data.total;
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    searchList() {
      this.getList(true);
    },
    // 表头排序翻转
    toggleSort(orderType) {
      if (this.searchModel.orderType === orderType) {
        this.searchModel.sortDir = this.searchModel.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.searchModel.orderType = orderType;
        this.searchModel.sortDir = 'asc';
      }
      this.getList(true);
    },
    // 获取排序图标（用Unicode字符，不依赖Element UI图标字体）
    getSortIcon(orderType) {
      if (this.searchModel.orderType === orderType) {
        return this.searchModel.sortDir === 'asc' ? '▲' : '▼';
      }
      return '▼';
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.pageIndex = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    selectClick(row) {
      mktBorrowView(row.id).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.viewForm = data;
          this.viewShow = true;
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    //出库
    outbound(row) {
      this.outboundForm = {
        detailId: row.id,
        deviceId: row.deviceId,
        prePhotos: '',
        devicestatus: '0',
        devicestatusOut: '0',
        remarkOut: ''
      };
      this.outboundFileList = [];
      this.outboundShow = true;
    },
    //不出库：物理删除该 detail，释放设备
    cancelOutbound(row) {
      const deviceName = row.deviceinfo ? row.deviceinfo.zcmc : '该设备';
      const deviceCode = row.deviceinfo ? row.deviceinfo.glbh : '';
      this.$confirm(
        `确定【${deviceName}（${deviceCode}）】不出库吗？\n\n确认后该设备将被释放，可借给其他人。`,
        "提示",
        {
          confirmButtonText: "确认不出库",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        // type="3" 表示不出库
        this.mktSetDeviceFun(row.id, row.deviceId, "3", '', '', '', '');
      }).catch(() => {});
    },
    uploadRequest(options) { //出库上传照片
      const formData = new FormData();
      formData.append('file', options.file);
      uploadImage(formData).then(res => {
        if (res.status === 200 && res.data && res.data.path) {
          // 追加上传后的地址
          if (this.outboundForm.prePhotos) {
            this.outboundForm.prePhotos += ',' + res.data.path;
          } else {
            this.outboundForm.prePhotos = res.data.path;
          }
          // 更新 file-list 显示
          options.onSuccess({ url: res.data.path }, options.file, this.outboundFileList);
        }
      }).catch(() => {
        options.onError();
      });
    },
    confirmOutbound() {
      if (!this.outboundForm.devicestatusOut) {
        this.$message.warning('请选择是否有损坏');
        return;
      }
      this.mktSetDeviceFun(this.outboundForm.detailId, this.outboundForm.deviceId, "1", this.outboundForm.prePhotos || '', this.outboundForm.devicestatusOut, this.outboundForm.remarkOut);
      this.outboundShow = false;
    },
    //入库
    store(row) {
      this.storeForm = {
        detailId: row.id,
        deviceId: row.deviceId,
        photos: '',
        devicestatus: '0',
        remark: ''
      };
      this.storeFileList = [];
      this.storeShow = true;
    },
    storeUploadRequest(options) { //入库上传照片
      const formData = new FormData();
      formData.append('file', options.file);
      uploadImage(formData).then(res => {
        if (res.status === 200 && res.data && res.data.path) {
          // 追加上传后的地址
          if (this.storeForm.photos) {
            this.storeForm.photos += ',' + res.data.path;
          } else {
            this.storeForm.photos = res.data.path;
          }
          // 更新 file-list 显示
          options.onSuccess({ url: res.data.path }, options.file, this.storeFileList);
        }
      }).catch(() => {
        options.onError();
      });
    },
    confirmStore() {
      if (!this.storeForm.devicestatus) {
        this.$message.warning('请选择是否有损坏');
        return;
      }
      this.mktSetDeviceFun(this.storeForm.detailId, this.storeForm.deviceId, "2", this.storeForm.photos || '', this.storeForm.devicestatus, '', this.storeForm.remark);
      this.storeShow = false;
    },
    mktSetDeviceFun(detailId, deviceId, type, prePhotos, devicestatus, remarkOut, remark) {
      const params = { detailId, deviceId, status: type };
      if (devicestatus !== undefined && devicestatus !== '') params.devicestatus = devicestatus;
      if (type == "1") {//出库
        params.devicestatusOut = devicestatus;
        if (prePhotos) params.prePhotos = prePhotos;
        if (remarkOut) params.remarkOut = remarkOut;
      }
      if (type == "2") {
        params.devicestatus = devicestatus;
        if (prePhotos) params.photos = prePhotos;
        if (remark) params.remark = remark;
      }
      // type == "3" 不出库：无需额外参数
      mktSetDevice(params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          if (type == "1") {
            this.$message({
              message: "出库成功，还剩 " + data.remainingQuantity + " 件未出库",
              type: "success",
            });
          }
          if (type == "2") {
            this.$message({
              message: "入库成功，还剩 " + data.remainingQuantity + " 件未出库",
              type: "success",
            });
          }
          if (type == "3") {
            this.$message({
              message: "不出库操作成功，该设备已释放",
              type: "success",
            });
          }
          let row = {};
          row.id = this.viewForm.id;
          this.selectClick(row);
          this.getList();
        } else {
          this.$message({
            message: message || "请求错误",
            type: "error",
          });
        }
      }).catch((error) => {
        this.$message({
          message: (error.response && error.response.data && error.response.data.message) || "请求错误",
          type: "error",
        });
      });
    },
    //查看借还记录
    viewLend(row) {
      this.lendForm = {};
      this.usageRecordRow = row;
      this.lendShow = true;
      mktBorrowViewDetail(row.id).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          // 处理图片URL数组
          if (data.prePhotoUrls && Array.isArray(data.prePhotoUrls)) {
            data.prePhotoUrls = data.prePhotoUrls.map(url => this.getFullUrl(url))
          }
          if (data.photoUrls && Array.isArray(data.photoUrls)) {
            data.photoUrls = data.photoUrls.map(url => this.getFullUrl(url))
          }
          this.lendForm = data;
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    // 打开使用记录弹窗
    openUsageRecord(row) {
      this.usageRecordList = [];
      this.usageRecordRow = row;
      const borrowId = row.id;
      const deviceId = row.deviceId;
      mktUsageRecordListByBorrowId({ borrowId, deviceId }).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.usageRecordList = data || [];
          this.usageRecordShow = true;
        } else {
          this.$message({
            message: message || "获取使用记录失败",
            type: "error",
          });
        }
      });
    },

    // 打开维护记录弹窗
    openMaintenanceRecord(row) {
      this.maintenanceRecordRow = row;
      this.maintenanceDeviceName = row.deviceinfo ? row.deviceinfo.zcmc : '';
      this.maintenanceRecordList = [];
      const borrowId = row.id;
      const deviceId = row.deviceId;
      mktMaintenanceRecordListByDeviceId(borrowId, deviceId).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.maintenanceRecordList = (data && data.list) ? data.list : [];
          this.maintenanceRecordShow = true;
        } else {
          this.$message({
            message: message || "获取维护记录失败",
            type: "error",
          });
        }
      });
    },
    // 显示新增维护记录弹窗
    showAddMaintenanceRecord() {
      this.maintenanceRecordForm = {
        borrowId: this.viewForm.id,
        deviceId: this.maintenanceRecordRow.deviceId,
        maintenanceTime: '',
        maintenanceContent: '',
        remark: ''
      };
      this.addMaintenanceRecordShow = true;
    },
    // 编辑维护记录
    editMaintenanceRecord(row) {
      this.maintenanceRecordForm = Object.assign({}, row);
      this.addMaintenanceRecordShow = true;
    },
    // 提交维护记录（有id为编辑，否则为新增）
    submitMaintenanceRecord() {
      if (!this.maintenanceRecordForm.maintenanceTime) {
        this.$message({ message: "请选择维护日期", type: "warning" });
        return;
      }
      if (!this.maintenanceRecordForm.maintenanceContent) {
        this.$message({ message: "请输入维护内容", type: "warning" });
        return;
      }
      const isEdit = !!this.maintenanceRecordForm.id;
      const request = isEdit
        ? mktMaintenanceRecordUpdate(this.maintenanceRecordForm)
        : mktMaintenanceRecordAdd(this.maintenanceRecordForm);
      request.then((datas) => {
        let { status, message } = datas;
        if (status == 200) {
          this.$message({ message: isEdit ? "修改成功" : "保存成功", type: "success" });
          this.addMaintenanceRecordShow = false;
          this.openMaintenanceRecord(this.maintenanceRecordRow);
        } else {
          this.$message({ message: message || "保存失败", type: "error" });
        }
      });
    },
    // 编辑使用记录
    editUsageRecord(row) {
      this.usageRecordEditForm = Object.assign({}, row);
      this.usageRecordEditShow = true;
    },
    submitUsageRecordEdit() {
      if (!this.usageRecordEditForm.useDate) {
        this.$message({ message: "请选择使用日期", type: "warning" });
        return;
      }
      mktUsageRecordUpdate(this.usageRecordEditForm).then((datas) => {
        let { status, message } = datas;
        if (status == 200) {
          this.$message({ message: "修改成功", type: "success" });
          this.usageRecordEditShow = false;
          this.openUsageRecord(this.usageRecordRow);
        } else {
          this.$message({ message: message || "修改失败", type: "error" });
        }
      });
    },
    // 删除使用记录
    deleteUsageRecord(id) {
      this.$confirm("确定删除该使用记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mktUsageRecordDelete(id).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.openUsageRecord(this.usageRecordRow);
          } else {
            this.$message({ message: message || "删除失败", type: "error" });
          }
        });
      });
    },
    // 删除维护记录
    deleteMaintenanceRecord(id) {
      this.$confirm("确定删除该维护记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        mktMaintenanceRecordDelete(id).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.openMaintenanceRecord(this.maintenanceRecordRow);
          } else {
            this.$message({ message: message || "删除失败", type: "error" });
          }
        });
      });
    },
    // 导出使用记录
    exportUsageRecord() {
      const borrowId = this.usageRecordRow.id;
      const deviceId = this.usageRecordRow.deviceId || this.usageRecordRow.id;
      mktUsageRecordExport({ borrowId, deviceId }).then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '设备使用记录.docx';
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message({ message: "导出成功", type: "success" });
        } else {
          this.$message({ message: "导出失败", type: "error" });
        }
      });
    },
    // 导出维护记录
    exportMaintenanceRecord() {
      const borrowId = this.maintenanceRecordRow.id;
      const deviceId = this.maintenanceRecordRow.deviceId || this.maintenanceRecordRow.id;
      mktMaintenanceRecordExport({ borrowId, deviceId }).then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '设备维护记录.docx';
          link.click();
          window.URL.revokeObjectURL(url);
          this.$message({ message: "导出成功", type: "success" });
        } else {
          this.$message({ message: "导出失败", type: "error" });
        }
      });
    },
    //选择设备的回调方法
    transferValue(selectInfo, rowInfo) {
      if (selectInfo.length == 0) {
        this.$message({
          message: "请至少选择一台设备",
          type: "warning",
        });
        return;
      } else if (selectInfo.length > 1) {
        this.$message({
          message: "只允许选择一台设备",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定调换为【" + selectInfo[0].zcmc + "】吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _params = {
          recordId: this.viewForm.id,
          oldId: rowInfo.deviceId,
          newId: selectInfo[0].id,
          exchangeRemark: "",
        };
        mktExchange(_params).then((datas) => {
          let { message, status } = datas;
          if (status == 200) {
            this.$message({ message: "调换成功", type: "success" });
            let row = {};
            row.id = this.viewForm.id;
            this.selectClick(row);
          } else {
            this.$message({ message: message, type: "error" });
          }
        });
      });
    },
    getRowKeys(row) {
      return row.id;
    },
    //审核
    auditHandle() {
      Object.assign(this.auditForm, {
        id: this.viewForm.id,
        status: null,
        remark: '',
      });
      this.auditShow = true;
    },
    import2Excel() {
      this.importDialogShow = true;
    },
    handleImportFile(file) {
      this.importFile = file.raw;
      return false;
    },
    confirmImport() {
      if (!this.importFile) {
        this.$message({
          message: "请选择要导入的文件",
          type: "warning",
        });
        return;
      }
      const formData = new FormData();
      formData.append('file', this.importFile);
      this.loadingUtil.showLoading("正在上传中，请稍后……");
      importMarketRecord(formData).then((result) => {
        let { status, message } = result;
        if (status == 200) {
          this.$message({
            message: "导入成功",
            type: "success",
          });
          this.importDialogShow = false;
          this.importFile = null;
          this.getList();
        } else {
          this.$message({
            message: message || "导入失败",
            type: "error",
          });
        }
        this.loadingUtil.hideLoading();
      }).catch((error) => {
        this.$message({
          message: (error.response && error.response.data && error.response.data.message) || "导入出错",
          type: "error",
        });
        this.loadingUtil.hideLoading();
      });
    },
    //导出借用台账
    export2Excel() {
      let _this = this;
      let ids = "";
      if (this.checkBoxData.length > 0) {
        ids = this.checkBoxData.map((item) => item.id).join();
      }
      this.loadingUtil.showLoading("正在下载中，请稍后……");
      let _params = {
        id: ids
      };
      exportMarketRecord(_params).then((resultData) => {
        const blob = new Blob([resultData]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = "设备借用台账.xlsx";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "设备借用台账.xlsx");
        }
        _this.loadingUtil.hideLoading();
      });
    },
    //审核
    auditOk() {
      this.$refs.auditForm.validate((valid) => {
        if (valid) {
          mktBorrowAudit(this.auditForm).then((datas) => {
            let { status, message, data } = datas;
            if (status == 200) {
              this.$message({
                message: message,
                type: "success",
              });
              Object.assign(this.auditForm, { id: null, status: null, remark: '' });
              this.auditShow = false;
              this.viewShow = false;
              this.getList();
            } else {
              this.$message({
                message: message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
  created() {
    this.getProjectOptions();
    this.getList();
  },
};
</script>
<style scoped>
.btn {
  float: left;
}

.statueBtn {
  padding: 10px 10px;
  border: 0px;
  float: left;
  margin-left: 10px;
}

.statueSpan {
  vertical-align: middle;
  float: left;
  margin-left: 5px;
}

/* .el-input__inner{
    height:40px!important
} */

.outbound-upload /deep/ .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

.outbound-upload /deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
</style>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style lang="less" scoped>
/deep/ .el-descriptions-item__label {
  width: 160px;
}

#deviceTable {
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    /*滚动条宽度*/
    height: 15px;
    /*滚动条高度*/
    margin-top: 100px;
  }

  /* 给固定列设置下边距 */
  /deep/ .el-table__fixed {
    height: auto !important;
    bottom: 15px !important;
    /* 具体值是多少根据你横向滚动条的高度进行设置 */
  }

  /deep/ .el-table__fixed-left {
    height: 100% !important;
  }

  /* 去掉固定列下方的横线 */
  /deep/ .el-table__fixed::before,
  .el-table__fixed-left::before {
    display: none;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ededed;
  }

  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #cfcbcb;
  }

  /deep/ .el-table__fixed-body-wrapper {
    height: calc(100% -57px) !important;
    padding-bottom: 17px;
    box-sizing: content-box;
  }

  /deep/ .tr-diaobo {
    color: red !important;
  }

  /deep/ .tr-baofei {
    color: #580fda !important;
  }

  /deep/ .tr-jiandin {
    color: #f4de5c !important;
  }
}

.el-table--border {
  border-color: #000000 !important;
  width: 320px;
  border-right: 1px solid #000000 !important;
  border-bottom: 1px solid #000000 !important;
}

#table /deep/ .cell {
  padding-left: 2px !important;
  padding-right: 0px !important;
}

.docx-wrapper {
  background: white !important;
  padding: 10px;
}

.docx {
  padding: 0pt 20.65pt 20pt 20.55pt !important;
  width: 789.9pt !important;
  min-height: 0px !important;
  margin-top: -30px !important;
  margin-left: -10px !important;
}

/deep/ .exchange div span {
  font-size: 14xp !important;
}

.exchange div {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/views/market/RecordConfirm.vue